import { useState } from "react";
import { Box, Button, Layer } from "grommet";
import PodExamCodesLayer from "../PodComponents/PodExamCodesLayer";
import PodPaymentValidation from "../PodPaymentValidation";
import ABMDI from "../PodIntegrations/ABMDI";
import PodHPEIntegration from "../PodIntegrations/HPE";
import Tocico from "../PodIntegrations/Tocico";
import AAAFoodHandlersPanel from "../PodIntegrations/AAAFoodHandlers";
import {
  getFieldValue,
  getPaymentReferenceId,
  hasPaymentValidationFields,
} from "./sessionUtils";

export default function IntegrationButtons({
  podSession,
  organization,
  podExamCodes,
  podNotesFormat,
  userEmail,
}) {
  const [showIntegrationLayer, setShowIntegrationLayer] = useState(false);
  const [showExamCodesLayer, setShowExamCodesLayer] = useState(false);
  const [paymentValidationOpen, setPaymentValidationOpen] = useState(false);

  const fields = podSession.fields ?? [];
  const showAbmdiIntegration = podSession.organizationId === "abmdi";
  const showHpeIntegration = podSession.organizationId === "hpe";
  const showTocicoIntegration = podSession.organizationId === "tocico";
  const showAaaFoodHandlerIntegration =
    podSession.organizationId === "aaa-food-handler";
  const tocicoId = getFieldValue(fields, "id");
  const showExamCodes = podExamCodes.length > 0;
  const canShowPaymentValidation = hasPaymentValidationFields(
    fields,
    podNotesFormat,
    podSession.organizationName,
  );
  const propertyLink = organization?.property_link;

  return (
    <>
      <Box direction="row" wrap gap="small">
        {showAbmdiIntegration && (
          <Button
            label="Open ABMDI Integration"
            primary
            color="black"
            onClick={() => setShowIntegrationLayer(true)}
          />
        )}
        {showHpeIntegration && (
          <Button
            label="Open HPE Integration"
            primary
            color="black"
            onClick={() => setShowIntegrationLayer(true)}
          />
        )}
        {showTocicoIntegration && (
          <Button
            label="Open TOCICO Integration"
            primary
            color="black"
            title={tocicoId ? `Matched exam ID: ${tocicoId}` : undefined}
            onClick={() => setShowIntegrationLayer(true)}
          />
        )}
        {showAaaFoodHandlerIntegration && (
          <Button
            label="Open AAA Food Handlers"
            primary
            color="black"
            onClick={() => setShowIntegrationLayer(true)}
          />
        )}
        {showExamCodes && (
          <Button
            label="Open Exam Codes"
            primary
            color="black"
            onClick={() => setShowExamCodesLayer(true)}
          />
        )}
        {canShowPaymentValidation && (
          <Button
            label="Payment Validation"
            primary
            color="black"
            onClick={() => setPaymentValidationOpen(true)}
          />
        )}
        {propertyLink && (
          <Button
            label="Property Tab"
            primary
            color="black"
            onClick={() => window.open(propertyLink, "_blank")}
          />
        )}
      </Box>

      {showExamCodesLayer && (
        <PodExamCodesLayer
          podExamCodes={podExamCodes}
          podSession={podSession}
          showExamCodesLayer={showExamCodesLayer}
          setShowExamCodesLayer={setShowExamCodesLayer}
        />
      )}

      {paymentValidationOpen && (
        <PodPaymentValidation
          referenceId={getPaymentReferenceId(fields)}
          email={podSession.testerEmail}
          lastFour={getFieldValue(fields, "appointmentid")}
          user={userEmail}
          setPaymentValidation={setPaymentValidationOpen}
        />
      )}

      {showIntegrationLayer && (
        <Layer
          position="right"
          full="vertical"
          modal
          onClickOutside={() => setShowIntegrationLayer(false)}
        >
          {showAbmdiIntegration && (
            <ABMDI
              sessionId={getFieldValue(fields, "abmdisessionid")}
              onClose={() => setShowIntegrationLayer(false)}
            />
          )}
          {showHpeIntegration && (
            <PodHPEIntegration
              name={podSession.testerName}
              onClose={() => setShowIntegrationLayer(false)}
            />
          )}
          {showTocicoIntegration && (
            <Tocico
              id={tocicoId || undefined}
              onClose={() => setShowIntegrationLayer(false)}
            />
          )}
          {showAaaFoodHandlerIntegration && (
            <AAAFoodHandlersPanel
              testerEmail={podSession.testerEmail}
              onClose={() => setShowIntegrationLayer(false)}
            />
          )}
        </Layer>
      )}
    </>
  );
}
